import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import $ from "jquery";
import { useTranslation } from "react-i18next";

const Password = (props) => {
    const { t } = useTranslation();
    return (
        <Fragment>
            {props.label && (
                <Form.Label className="w-100">
                    {props.label} <span className="text-danger">*</span>
                </Form.Label>
            )}
            {props.helper && <p className="mb-2 text-small">{t("passwordHelper")}</p>}
            <Form.Control
                value={props.value}
                onChange={(e) => {
                    $(`#${props.controlID}`).removeClass("is-invalid");
                    props.onChange(e);
                }}
                placeholder={t(props.rpp ? "repeatPasswordPlaceholder" : "passwordPlaceholder")}
                type="password"
                aria-describedby={props.btnID}
                autoComplete={props.autoComplete}
                disabled={props.disabled}
            />
        </Fragment>
    );
};

export default Password;
